import { FC, PropsWithChildren } from 'react'

/**
 * Full-screen layout with the Vendome building background image.
 * Renders a relative/absolute stack so content sits on top of the background.
 *
 * @example
 * <VendomeLayout>
 *   <MyCard />
 * </VendomeLayout>
 */
export const VendomeLayout: FC<PropsWithChildren> = ({ children }) => (
  <div className="relative min-h-screen overflow-hidden">
    <div className="absolute inset-0 bg-[url(/img/vendome.webp)] bg-cover bg-center bg-no-repeat" />
    <div className="relative z-10 flex min-h-screen *:flex-1">{children}</div>
  </div>
)
